import axiosInstance from "../../api/axiosInstance";

export const fetchTournamentsAPI = async () => {
  const tournamentsList = await axiosInstance.get(
    "tournaments/get-all-tournaments"
  );

  return tournamentsList.data;
};

export const fetchTournamentsByStatusesAPI = async (page, limit, statuses) => {
  const tournamentsList = await axiosInstance.get(
    `tournaments/get-tournaments-by-statuses?page=${page}&limit=${limit}&statuses=${statuses}`
  );

  return tournamentsList.data;
};

export const fetchPaginatedTournamentsAPI = async (page, limit) => {
  const tournamentsList = await axiosInstance.get(
    `tournaments/get-paginated-tournaments?page=${page}&limit=${limit}`
  );

  return tournamentsList.data;
};

export const fetchTournamentsStatusesAPI = async () => {
  const tournamentsStatusesList = await axiosInstance.get(
    "tournaments/get-tournament-all-statuses"
  );

  return tournamentsStatusesList.data;
};

export const createTournamentAPI = async (tournamentData) => {
  const newTournament = await axiosInstance.post(
    "tournaments/create-tournament-v2",
    tournamentData
  );

  return newTournament.data;
};

export const deleteTournamentAPI = async (id) => {
  const deleteTournament = await axiosInstance.delete(
    `tournaments/delete-tournament/${id}`
  );

  return deleteTournament.data;
};

export const updateTournamentAPI = async (id, tournamentData) => {
  const updatedTournament = await axiosInstance.put(
    `tournaments/update-tournament/${id}`,
    tournamentData
  );

  return updatedTournament.data;
};
